module.exports = __webpack_public_path__ + "img/quiz-leaf.5a83e7cc.svg";